const registerableResourceConstants = {
    INVALID_REGISTRATION_IDENTIFIER_ERROR : 'Invalid registrationIdentifier!'

};

angular.module('gw-um-j2js')
    .constant('registerableResourceConstants', registerableResourceConstants);